export default __webpack_public_path__ + "static/media/template31.f7bf9533.svg";